import React, { memo, useCallback } from 'react';
import { Button } from 'antd';
import Link from 'next/link';
import { useDispatch } from 'react-redux';
import styles from './index.module.scss';

export type UnlockFailModalContentProps = {
  conBrandId?: string;
};

const UnlockFailModalContent: React.FC<UnlockFailModalContentProps> = () => {
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    dispatch({ type: 'modal/close' });
  }, [dispatch]);
  return (
    <section className={styles.content}>
      <img src="//assets-oss.cbndata.com/cbndata-refactor-fe/FlgyLZ7mCMnyFG155Ybx0Lun9hCh.svg" alt="解锁失败" />
      <h1 className={styles.title}>解锁失败！</h1>
      <span className={styles.text}>
        该品牌与您所属品牌不在同一行业，无法解锁若想解锁该品牌，请联系客服升级会员等级
      </span>
      <div className={styles.btnContainer}>
        <Link href="/brand">
          <Button className={styles.btn} type="primary" size="large" onClick={onClick}>
            去解锁同行业品牌
          </Button>
        </Link>
        <Link href="/member">
          <Button className={styles.btn} type="primary" size="large" onClick={onClick}>
            了解详情
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default memo(UnlockFailModalContent);
